import * as React from "react";
import * as ReactDOM from "react-dom";

import {ProgressRingControl} from "../../../../Intercom.ReactUI/Views/index";

export interface FullPageStatusComponentProps extends React.Props<FullPageStatusComponent> {
    message: string;
}

export class FullPageStatusComponent extends React.Component<FullPageStatusComponentProps, {}> {
    public render(): JSX.Element {
        return (
            <div className="full-page-center full-page-status">
                <ProgressRingControl className="progress-large"/>
                <div className="page-status-message">
                    {this.props.message}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/FullPageStatusComponent.tsx